<template>
    <div class="custom-control custom-radio" :class="{ 'custom-control-inline': inline }">
        <input :id="id"
               v-model="valModel"
               class="custom-control-input"
               type="radio"
               :name="name"
               :value="val"
               :disabled="disabled"
               @blur="onBlur">
        <label class="custom-control-label" :for="id">{{ $t(label) }}</label>
    </div>
</template>

<script>
export default {
    name: 'AppRadio',
    props: {
        value: [Boolean, String, Number],
        val: [Boolean, String, Number],
        id: String,
        name: String,
        label: String,
        disabled: Boolean,
        inline: Boolean
    },
    computed: {
        valModel: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        onBlur(value) {
            this.$emit('blur', value);
        }
    }
};
</script>

<style lang="scss" scoped>
.custom-control {
    &.is-invalid {
        .custom-control-label {
            &::before {
                border-color: #f16891;
            }
        }
    }
}
.custom-control-inline {
    display: inline-flex;
    margin-right: 0.5rem;
}
</style>
